import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Guarantee() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-brand-bg relative" data-id="element-135">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-brand-darker to-brand-bg border-2 border-brand-cyan/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-137">
          {/* Decorative background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-brand-cyan/10 blur-[80px] rounded-full pointer-events-none" data-id="element-138"></div>

          <div className="relative z-10" data-id="element-139">
            <div className="inline-flex items-center justify-center bg-brand-cyan/10 p-4 rounded-full mb-6" data-id="element-140">
              <ShieldCheck className="w-12 h-12 text-brand-cyan" data-id="element-141" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-142">
              {t('guarantee.title')}
            </h2>

            <div className="space-y-6 text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-143">
              <p data-id="element-144">
                {t('guarantee.text1')}{' '}
                <strong className="text-brand-cyan" data-id="element-145">
                  {t('guarantee.text2')}
                </strong>
                ...
                <br data-id="element-146" />
                {t('guarantee.text3')}{' '}
                <strong className="text-white" data-id="element-147">{t('guarantee.text4')}</strong>
              </p>

              <p className="font-medium text-white" data-id="element-148">{t('guarantee.text5')}</p>

              <p className="text-brand-cta font-bold text-2xl pt-4" data-id="element-149">
                {t('guarantee.text6')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}